var app = angular.module('leonardo');

var NoteAddFilter = function () {
  return function (note_required) {
    return note_required ? 'YES' : '';
  }
};

app.filter('noteadd', [NoteAddFilter]);
